import { react } from 'react';
import classes from './Footer.module.css';

const Footer=()=>{
    return (
        <div className={classes.footer}>
           All rights reserved@Autozilla 2022
        </div>
    );
}

export default Footer;